<div class="d-flex flex-row justify-content-evenly">
	<div class="w-100 px-2">
		<ng-select
			class="w-100 h-100"
			placeholder="Wybierz produkt"
			[disabled]="editable"
			[(ngModel)]="filters.product"
			multiple="true"
			[minTermLength]="minLengthTerm"
			[loading]="productLoading"
			loadingText="Wczytywanie..."
			typeToSearchText="Wprowadź {{ minLengthTerm }} lub więcej znaków"
			[typeahead]="productsInput$"
			><ng-option *ngFor="let item of products$ | async" [value]="item.id">{{ item.name }} </ng-option></ng-select
		>
	</div>
	<div class="w-100 px-2">
		<mat-form-field>
			<mat-label>Zakres</mat-label>
			<mat-date-range-input [disabled]="editable" [rangePicker]="picker">
				<input matStartDate matInput placeholder="Od" [(ngModel)]="date.lower" />
				<input matEndDate matInput placeholder="Do" [(ngModel)]="date.upper" (dateChange)="updateDate()" />
			</mat-date-range-input>
			<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>
	</div>
	<div class="w-100 px-2">
		<mat-form-field>
			<input
				matInput
				type="number"
				placeholder="Ilość noclegów"
				[disabled]="editable"
				(change)="updateNights()"
				[(ngModel)]="nights"
			/>
		</mat-form-field>
	</div>
	<div class="w-100 px-2">
		<ng-select placeholder="Status" [(ngModel)]="filters.term_price_status" [disabled]="editable" multiple="true"
			><ng-option [value]="item.value" *ngFor="let item of statusSet">{{ item.name }}</ng-option>
		</ng-select>
	</div>
</div>
<mat-divider></mat-divider>
<div class="d-flex flex-row justify-content-end py-3">
	<button mat-button [disabled]="editable" (click)="filtersClear()">Wyczyść filtry</button>
	<button mat-raised-button color="primary" [disabled]="editable" (click)="checkEdit()">Filtruj</button>
</div>
